import type { ContestType } from '@betterpool/api-types/contests-service';

import type { FullContestTeam } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';

import getIsAfterPickDeadline from '../../../common/context/SlatesContext/utils/getIsAfterPickDeadline';
import parseSlateBase from '../../../common/context/SlatesContext/parseSlates/parseBaseSlate';
import getPicksLabelBar from '../../../common/utils/getMakePicksLabel';

type SlateWithStateAndSettingsTeam = {
  contestType: ContestType.TEAM_PICK_EM | ContestType.TEAM_SURVIVOR;
  id: string;
  slate: ContestSlate;
  state: {
    isAfterPickDeadline: boolean;
    isGenerated?: boolean;
    picksLabel?: string;
  };
  settings: {
    expectedPicksCount: number;
  };
};

function parseSlateTeamBase(
  contest: FullContestTeam,
  slate: ContestSlate,
  index: number
): SlateWithStateAndSettingsTeam {
  const isAfterPickDeadline = getIsAfterPickDeadline(contest, slate);

  const baseSlate = parseSlateBase(contest, slate, index);

  return {
    ...baseSlate,
    contestType: contest.contest_type,
    state: {
      ...baseSlate.state,
      picksLabel:
        !isAfterPickDeadline && slate.isPicksheetAvailable
          ? getPicksLabelBar(contest, slate)
          : undefined,
    },
  };
}

export default parseSlateTeamBase;

export type { SlateWithStateAndSettingsTeam };
